export function getLocaleAgreement({ jwt }) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/pd/getLocaleAgreements`, {
    method: "GET",
    mode: "cors",
    headers: { Authorization: `Bearer ${jwt}` },
  })
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
      throw response
    })
    .then((payload) => ({ payload }))
    .catch((error) => ({ error }))
}

export function putLocaleAgreement({ jwt, params }) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/pd/putLocaleAgreements`, {
    method: "PUT",
    body: JSON.stringify({
      location_agree: String(params.locationAgree),
    }),
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${jwt}`,
    },
  })
    .then((response) => {
      if (response.ok) {
        return response.json()
      }
      throw response
    })
    .then((payload) => ({ payload }))
    .catch((error) => ({ error }))
}
